import { render } from "./SiloPage.vue?vue&type=template&id=695a41ed"
import script from "./SiloPage.vue?vue&type=script&lang=js"
export * from "./SiloPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__